/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

import { Component } from 'llama'
import FaceDrawer from '../../common/FaceDrawer'
import FacePartSelector from './FacePartSelector'

export default class FacePartBody extends Component {
  constructor (opt) {
    super({
      ...opt,
      html: () => '<div id="part-choice-body" class="part-choice two-cols"></div>'
    })
  }

  init (params, path) {
    const { eventBus, context } = this

    const faceDrawer = new FaceDrawer()
    this.addChildren(
      params, path,

      new FacePartSelector({
        eventBus,
        context,
        box: 'part-choice-body',
        num: 2,
        draw (cnv, i) {
          faceDrawer.drawBodyAndUnderwear(cnv, i, 0.6, { left: 30, top: -55 })
        },
        shape: 'body',
        width: 120,
        height: 240
      })
    )
  }
}
